import React from 'react'
import { useNavigate } from 'react-router-dom'
import Mannol from './layout/assets/BrandLogos/Mannol.png';
import Mobil from './layout/assets/BrandLogos/Mobil.png';
import Motul from './layout/assets/BrandLogos/Motul.png';
import Selenia from './layout/assets/BrandLogos/Selenia.png';
import Shell from './layout/assets/BrandLogos/Shell.png';
import Total from './layout/assets/BrandLogos/Total.png';
import Valvoline from './layout/assets/BrandLogos/Valvoline.png';
import Fuchs from './layout/assets/BrandLogos/Fuchs.png';
import LiquiMoly from './layout/assets/BrandLogos/LiquiMoly.png';
import Castrol from './layout/assets/BrandLogos/Castrol.png';
import Elf from './layout/assets/BrandLogos/Elf.png';
import Aral from './layout/assets/BrandLogos/Aral.png';

function Brands() {
    const navigate = useNavigate()

    const brands = [
        { id: 1, url: Mobil, link: '/oils?manufacturer=Mobil' },
        { id: 2, url: Motul, link: '/oils?manufacturer=Motul' },
        { id: 3, url: Valvoline, link: '/oils?manufacturer=Valvoline' },
        { id: 4, url: Castrol, link: '/oils?manufacturer=Castrol' },
        { id: 5, url: Shell, link: '/oils?manufacturer=Shell' },
        { id: 6, url: Fuchs, link: '/oils?manufacturer=Fuchs' },
        { id: 7, url: Total, link: '/oils?manufacturer=Total' },
        { id: 8, url: Mannol, link: '/oils?manufacturer=Mannol' },
        { id: 9, url: LiquiMoly, link: '/oils?manufacturer=Liqui Moly' },
        { id: 10, url: Elf, link: '/oils?manufacturer=Elf' },
        { id: 11, url: Aral, link: '/oils?manufacturer=Aral' },
        { id: 12, url: Selenia, link: '/oils?manufacturer=Selenia' },
    ];

    const handleNavigate = (link) => {
        navigate(link);
    }

    return (
        <div className="p-6">
            <div className="flex flex-wrap justify-center gap-6">
                {brands.map((brand) => (
                    <div key={brand.id} className="flex flex-col items-center">
                        <div className="w-32 h-32 rounded-lg border-4 border-orange-200 p-2">

                            <img
                                src={brand.url}
                                alt={`Brand ${brand.id}`}
                                className="w-full h-full object-contain rounded-lg cursor-pointer"
                                onClick={() => handleNavigate(brand.link)}
                            />

                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Brands
